type PartialCalendarEvent = Partial<{
  prodId: string | null | undefined;
  holderConnection: {
    edges: Array<{
      node: {
        __typename: string;
        uuid: string;
        showImportedLessonEvents?: boolean;
      };
    }>;
  };
}>;

export const filterEventsByHolderSettings = <T extends PartialCalendarEvent>(events: Array<T>): Array<T> => {
  // if Holder of type Group has showImportedLessonEvents===false, filter out events whose prodId !== 'bp'

  return events.filter((e) => {
    const groupEvents = e.holderConnection?.edges.filter((edge) => edge.node.__typename === 'Group');
    // return event if holder is NOT a group
    if (!groupEvents || groupEvents.length === 0) return true;

    // holder is a group
    const dontShowImportedEvents = groupEvents.filter((event) => {
      return !event.node.showImportedLessonEvents;
    });

    return dontShowImportedEvents.length > 0 ? e.prodId === 'bp' : true;
  });
};
